import React from 'react';

import { Text, WrapperFlex } from '@unimed-fesp/components';

// #region import componentes
import Skeleton from '../../atoms/Skeleton';
// #endregion

import { ModalidadesSelecionadasContainer } from './styles';
import theme from '../../../styles/theme';

const CounterContainer = ({ response, loading }) => {
  return !loading ? (
    Object.keys(response).map((resp) => {
      return (
        <ModalidadesSelecionadasContainer key={resp}>
          <Text font="12px calibri regular" text={`${resp} selecionadas:`} />
          <Text
            font="Bold 13px calibri"
            text={response[resp]}
            marginLeft={7}
            color={theme.greenLink}
          />
        </ModalidadesSelecionadasContainer>
      );
    })
  ) : (
    <ModalidadesSelecionadasContainer>
      <WrapperFlex column>
        <Skeleton height="13px" width="150px" marginUpDown="4" />
        <Skeleton height="13px" width="150px" marginUpDown="4" />
        <Skeleton height="13px" width="150px" marginUpDown="4" />
      </WrapperFlex>
    </ModalidadesSelecionadasContainer>
  );
};

export default CounterContainer;
